import buildUrl from 'modules/core/lib/buildUrl'

const documentDownloadUrl = (documentId: number, bookkeeperView = false) => {
  return buildUrl(
    `/documents/${documentId}?download=true&inline=true&bookkeeper_view=${bookkeeperView}`
  )
}

export default documentDownloadUrl
